<template>
  <section class="people_center_home">
    <empty
      v-if="
        !isFirst &&
        !videoLength &&
        !articleLength &&
        !likeLength &&
        !activityLength &&
        !subjectLength &&
        !liveList.length &&
        !collectList.length
      "
      url="/static/v2/peopleCenter/all_empty.png"
      :content="$t('global.还没有发布的内容')"
      :_style="{ width: '88px', height: '88px' }"
    />
    <div class="video-list section-list" v-if="videoList.length">
      <h5>
        {{ $t("global.发布的作品") }}
        <small>{{ videoLength }}</small>
        <nav-to class="nav-to" :title="$t('global.查看全部')" link="video" />
      </h5>
      <video-card
        v-if="videoDetail.id"
        :item="videoDetail"
        :language="language"
        :type="1"
      />
      <ul class="other-video-list">
        <li v-for="item in videoList.slice(1, 5)" :key="item.videoId">
          <video-card2 :item="item" :language="language" :isUser="true" />
        </li>
      </ul>
      <div class="more-video">
        <router-link to="video">
          <span
            v-html="$t('global.查看全部x个作品', { count: videoLength })"
          ></span>
        </router-link>
      </div>
    </div>
    <div class="article-list section-list" v-if="articleList.length">
      <h5>
        {{ $t("global.发布的文章") }}
        <small>{{ articleLength }}</small>
        <nav-to class="nav-to" :title="$t('global.查看全部')" link="article" />
      </h5>
      <ul class="other-article-list">
        <li v-for="item in articleList" :key="item.id">
          <article-card :item="item" :language="language" />
        </li>
      </ul>
    </div>
    <div class="article-list section-list" v-if="liveList.length">
      <h5>
        {{ $t("live.参与的直播") }}
        <small>{{ liveListLength }}</small>
        <nav-to class="nav-to" :title="$t('global.查看全部')" link="live" />
      </h5>
      <ul class="other-article-list">
        <li
          v-for="item in liveList"
          :key="item.id"
          class="liveList"
          @click="gotoLiveDetail(item.id)"
        >
          <div class="topLive">
            <span
              class="status status-notstarted"
              v-if="item.liveStatus == 2"
              >{{ $t("live.即将开始") }}</span
            >
            <span class="status status-living" v-if="item.liveStatus == 1">
              <img src="/static/icon_app_live_on_white.gif" alt />
              {{ $t("live.直播中") }}
            </span>
            <span class="status status-closed" v-if="item.liveStatus == 3">{{
              $t("global.已结束")
            }}</span>
            <img :src="item.horizontalThumb | imageUrl('', 350, 197)" />
            <div class="popIntroduction">
              <p class="introduction">{{ item.intro }}</p>
            </div>
          </div>
          <div class="rightLive">
            <p class="liveTitle">{{ item.title }}</p>
            <p class="begin-time">{{ formatDate(item.liveStartTime, 1) }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="myCollect" v-if="collectList.length">
      <h5>
        {{$t('collect.创建的看单')}}
        <small>{{ collectLength }}</small>
        <nav-to class="nav-to" :title="$t('global.查看全部')" link="collect" />
      </h5>
      <ul class="other-collect-list clearfix">
        <li class="collectLi" v-for="item in collectList" :key="item.id">
          <collectItem :item="item" />
        </li>
      </ul>
    </div>
    <div class="like-list section-list" v-if="likeList.length">
      <h5>
        {{ $t("global.喜欢的作品") }}
        <small>{{ likeLength }}</small>
        <nav-to class="nav-to" :title="$t('global.查看全部')" link="like" />
      </h5>
      <ul class="other-like-list">
        <li v-for="item in likeList" :key="item.videoId">
          <video-card2 :item="item" :language="language" />
        </li>
      </ul>
    </div>
    <div class="activity-list section-list" v-if="activityList.length">
      <h5>
        {{ $t("global.发布的活动") }}
        <small>{{ activityLength }}</small>
        <nav-to class="nav-to" :title="$t('global.查看全部')" link="activity" />
      </h5>
      <ul class="other-activity-list">
        <li v-for="item in activityList" :key="item.id">
          <activity-card :item="item" :language="language" />
        </li>
      </ul>
    </div>
    <div class="subject-list section-list" v-if="subjectList.length">
      <h5>
        {{ $t("global.关注的频道") }}
        <small>{{ subjectLength }}</small>
        <span class="nav-to" @click="showDialog">
          {{ $t("global.查看全部") }}
          <img src="/static/v2/match/view_all_tri.png" />
        </span>
      </h5>
      <ul class="other-subject-list">
        <li v-for="item in subjectList" :key="item.id">
          <subject-card
            class="subject-card"
            :item="item"
            :language="language"
          />
        </li>
      </ul>
    </div>
    <el-dialog
      class="person-center-home-dialog"
      :visible.sync="visible"
      top="5vh"
      :close-on-click-modal="false"
      width="1110px"
      :before-close="handleClose"
    >
      <span slot="title" class="dialog-title">
        {{ $t("global.关注的频道") }}
        <b>{{ subjectLength }}</b>
      </span>
      <div class="person-center-home-subject">
        <ul>
          <li v-for="item in allSubjectList" :key="item.id">
            <subject-card
              class="subject-card"
              :item="item"
              :language="language"
            />
          </li>
        </ul>
        <Loading v-if="loading" />
        <Reload v-if="loadError" @callback="loadMore" />
        <no-more v-if="!hasNextPage && allSubjectList.length" />
      </div>
    </el-dialog>
  </section>
</template>

<script>
import VideoCard from "@/components/v2/peopleCenter/VideoCard";
import VideoCard2 from "@/components/v2/peopleCenter/VideoCard2";
import ArticleCard from "@/components/v2/peopleCenter/ArticleCard";
import ActivityCard from "@/components/v2/peopleCenter/ActivityCard";
import SubjectCard from "@/components/v2/peopleCenter/SubjectCard";
import Reload from "@/components/v2/match/reload";
import Loading from "@/components/v2/match/loading";
import NavTo from "@/components/v2/NavTo";
import Empty from "@/components/v2/Empty";
import NoMore from "@/components/v2/NoMore";
import collectItem from "@/components/collect/collectItem";
export default {
  metaInfo() {
    return {
      title: this.$t("global.主页") + " | MANA",
    };
  },
  components: {
    VideoCard,
    VideoCard2,
    ArticleCard,
    ActivityCard,
    SubjectCard,
    collectItem,
    NavTo,
    Reload,
    Loading,
    Empty,
    NoMore,
  },
  data() {
    return {
      userId: null,
      isFirst: true,
      showVideo: false,
      videoList: [],
      videoLength: 0,
      videoDetail: {},
      articleList: [],
      articleLength: 0,
      likeList: [],
      likeLength: 0,
      activityList: [],
      activityLength: 0,
      liveList: [],
      liveListLength: 0,
      subjectList: [],
      subjectLength: 0,
      visible: false,
      allSubjectList: [],
      pageIndex: 1,
      pageSize: 10,
      loading: false,
      loadError: false,
      hasNextPage: false,
      collectList: [],
      collectLength: 0,
    };
  },
  created() {
    this.init();
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  beforeRouteLeave(to, from, next) {
    document.querySelector(".el-dialog__body") &&
      document
        .querySelector(".el-dialog__body")
        .removeEventListener("scroll", this.loadMore, false);
    next();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.userId !== from.params.userId) {
      setTimeout(() => {
        this.init();
      });
    }
    next();
  },
  methods: {
    init() {
      this.userId = this.$route.params.userId;
      this.getVideoList();
      this.getArticleList();
      this.getLiveList();
      this.getCollectList();
      this.getActivityList();
      this.getLikeList();
      this.getSubjectList();
      setTimeout(() => {
        this.isFirst = false;
      }, 2000);
    },
    showDialog() {
      this.visible = true;
      this.pageIndex = 1;
      this.getAllSubjectList();
      setTimeout(() => {
        document
          .querySelector(".el-dialog__body")
          .addEventListener("scroll", this.loadMore);
      }, 0);
    },
    handleClose() {
      this.pageIndex = 1;
      document
        .querySelector(".el-dialog__body")
        .removeEventListener("scroll", this.loadMore, false);
      this.visible = false;
      this.allSubjectList = [];
    },
    getVideoList() {
      const url = `/api/mobile/2.0/u/getVideoList`;
      const params = {
        userId: this.userId,
        order: 0,
        pageIndex: 1,
        pageSize: 5,
      };
      this.$http.get(url, { params }).then((res) => {
        if (res.code === "OK") {
          this.videoList = res.data.list;
          this.videoLength = res.data.totalRecord;
          this.videoDetail = this.videoList[0];
        }
      });
    },
    getCollectList() {
      const url = `/api/fav/createList/` + this.userId;
      const params = {
        userId: this.userId,
        pageIndex: 1,
        pageSize: 3,
      };
      this.$http.get(url, { params }).then((res) => {
        if (res.code === "OK") {
          this.collectList = res.data.list;
          this.collectLength = res.data.totalRecord;
        }
      });
    },
    getArticleList() {
      const url = `/api/mobile/u/getArticleList`;
      const params = {
        userId: this.userId,
        order: 0,
        pageIndex: 1,
        pageSize: 3,
      };
      this.$http.get(url, { params }).then((res) => {
        if (res.code === "OK") {
          this.articleList = res.data.list;
          this.articleLength = res.data.totalRecord;
        }
      });
    },
    getLiveList() {
      const url = `/api/bytedance/user/all/` + this.userId;
      const params = {
        pageIndex: 1,
        pageSize: 2,
      };
      this.$http.get(url, { params }).then((res) => {
        if (res.code === "OK") {
          this.liveList = res.data.list;
          this.liveListLength = res.data.totalRecord;
        }
      });
    },
    gotoLiveDetail(id) {
      if (id) {
        let routeData = this.$router.resolve({
          path: "/live/liveDetail?id=" + id,
        });
        window.open(routeData.href, "_blank");
      }
    },
    getActivityList() {
      const url = `/api/mobile/u/getActivityList`;
      const params = {
        userId: this.userId,
        pageIndex: 1,
        pageSize: 3,
      };
      this.$http.get(url, { params }).then((res) => {
        if (res.code === "OK") {
          this.activityList = res.data.list;
          this.activityLength = res.data.totalRecord;
        }
      });
    },
    getLikeList() {
      const url = `/api/mobile/u/getLikeVideoList`;
      const params = {
        userId: this.userId,
        pageIndex: 1,
        pageSize: 4,
      };
      this.$http.get(url, { params }).then((res) => {
        if (res.code === "OK") {
          this.likeList = res.data.list;
          this.likeLength = res.data.totalRecord;
        }
      });
    },
    getSubjectList() {
      const url = `/api/customer/topicList/${this.userId}`;
      const params = {
        type: 0,
        pageIndex: 1,
        pageSize: 4,
      };
      this.$http.get(url, { params }).then((res) => {
        if (res.code === "OK") {
          this.subjectList = res.data.list;
          this.subjectLength = res.data.totalRecord;
        }
      });
    },
    getAllSubjectList() {
      this.loading = true;
      const url = `/api/customer/topicList/${this.userId}`;
      const params = {
        type: 0,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      this.$http.get(url, { params }).then((res) => {
        this.loading = false;
        if (res.code === "OK") {
          this.loadError = false;
          if (this.pageIndex === 1) {
            this.allSubjectList = [];
          }
          this.hasNextPage = res.data.hasNextPage;
          this.allSubjectList = [...this.allSubjectList, ...res.data.list];
        } else {
          if (this.pageIndex !== 1) {
            this.pageIndex--;
          }
          this.loadError = true;
        }
      });
    },
    loadMore() {
      const scrollTop = document.querySelector(".el-dialog__body").scrollTop;
      const height = document.querySelector(".el-dialog__body").offsetHeight;
      const offsetHeight = document.querySelector(".person-center-home-subject")
        .offsetHeight;
      if (scrollTop + height > offsetHeight) {
        if (!this.loading && this.hasNextPage) {
          this.pageIndex++;
          this.getAllSubjectList();
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.people_center_home {
  padding-bottom: 80px;

  .other-collect-list {
    li.collectLi {
      float: left;
      margin-right: 30px;
      &:nth-child(3) {
        margin-right:0;
      }
    }
  }

  h5 {
    padding: 30px 0;
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #0A0A0A;

    small {
      font-size: 20px;
      font-family: NunitoSans-SemiBold, NunitoSans;
      font-weight: 600;
      color: #999;
      padding-left: 5px;
    }

    .nav-to {
      float: right;
      display: inline-block;
      width: 60px;
      color: #0A0A0A;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      position: relative;
      margin-right: 12px;
      margin-top: 7px;
      font-family: PingFang SC;

      &:hover {
        border-bottom: 1px solid #0A0A0A;
      }

      img {
        position: absolute;
        margin-top: 6px;
        width: 7px;
        height: 9px;
        right: -8px;
      }
    }
  }

  .article-list h5 {
    padding-bottom: 5px;
  }

  .like-list h5 {
    padding-bottom: 0;
  }

  .section-list {
    // padding-bottom: 40px;
    .other-video-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;

      li {
        width: 350px;
        padding-top: 30px;
      }
    }

    &.video-list {
      display: flex;
      flex-direction: column;

      .more-video {
        margin: 40px auto 0;

        a {
          display: inline-flex;
          height: 40px;
          border: 1px solid #333;
          align-items: center;
          padding: 9px 27px;
          box-sizing: border-box;

          span {
            line-height: 22px;
            font-size: 16px;
            color: #333;

            &::before {
              content: '';
              display: inline-block;
              width: 8px;
              height: 10px;
              background: url('/static/v2/match/view_all_tri.png');
              background-size: 8px 10px;
              margin-right: 8px;
            }

            &>>>.n {
              font-weight: bold;
              font-style: normal;
            }
          }

          &:hover {
            background: #F5F5F5;
          }
        }
      }
    }

    .other-article-list {
      font-size: 0;

      li {
        padding: 25px 0;
        border-bottom: 1px solid #EBEBEB;
      }

      li.liveList {
        border-bottom: none;
        width: 350px;
        margin-right: 30px;
        display: inline-block;
        cursor: pointer;

        &:nth-child(2) {
          margin-right: 0;
        }

        .topLive {
          width: 350px;
          height: 197px;
          position: relative;

          img {
            display: inline-block;
            width: 100%;
            height: 100%;
          }

          &:hover .popIntroduction {
            display: block;
          }

          .popIntroduction {
            positioN: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: rgba(10, 10, 10, 0.7);
            display: none;

            .introduction {
              position: absolute;
              max-height: 60px;
              font-size: 13px;
              font-family: NunitoSans-Regular, NunitoSans;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 20px;
              width: 100%;
              padding: 0 20px;
              box-sizing: border-box;
              left: 0;
              bottom: 50px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              word-break: break-word;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
            }
          }

          .status {
            position: absolute;
            bottom: 0;
            left: 0;
            padding: 0 12px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            background-size: 100%;
            font-size: 13px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            z-index: 111;
            border-radius: 0px 4px 0px 0px;
          }

          .status-notstarted {
            background: linear-gradient(135deg, rgba(54, 100, 237, 0.9) 0%, rgba(32, 38, 204, 0.9) 100%);
          }

          .status-living {
            background: linear-gradient(135deg, rgba(254, 161, 116, 0.9) 0%, rgba(254, 86, 48, 0.9) 100%);

            img {
              display: inline-block;
              width: 18px;
              height: 18px;
              vertical-align: text-top;
              margin-right: 4px;
            }
          }

          .status-closed {
            background: linear-gradient(135deg, rgba(204, 204, 204, 0.9) 0%, rgba(153, 153, 153, 0.9) 100%);
          }
        }

        .rightLive {
          width: 350px;

          .liveTitle {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 23px;
            font-size: 15px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(10, 10, 10, 1);
            line-height: 23px;
            margin-top: 10px;
          }

          .begin-time {
            margin-top: 6px;
            font-size: 13px;
            font-family: NunitoSans-Regular, NunitoSans;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          }
        }
      }
    }

    .other-like-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;

      li {
        width: 350px;
        padding: 25px 0;
      }
    }

    .other-activity-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      li {
        width: 223px;
        padding-right: 30px;

        &:nth-child(3n) {
          padding-right: 0;
        }
      }
    }

    .other-subject-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      li {
        width: 160px;
        padding-right: 30px;

        &:nth-child(4n) {
          padding-right: 0;
        }

        .subject-card {
          width: 160px;
        }
      }
    }
  }

  .person-center-home-subject {
    width: 1070px;

    ul {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding: 0 45px 10px;
      width: 1070px;
      box-sizing: border-box;

      li {
        width: 160px;
        margin-right: 45px;

        &:nth-child(5n) {
          margin-right: 0;
        }

        &:nth-child(n+6) {
          margin-top: 40px;
        }
      }
    }
  }
}
</style>
<style lang="stylus">
.person-center-home-dialog {
  .el-dialog {
    height: calc(95vh - 10px);
    overflow: hidden;
    margin-bottom: 0;
  }

  .el-dialog__header {
    border-bottom: 1px solid #E0E0E0;

    .dialog-title {
      font-size: 15px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #0A0A0A;
      padding-left: 45px;

      b {
        color: #666666;
        font-size: 14px;
      }
    }
  }

  .el-dialog__body {
    height: calc(95vh - 122px);
    overflow-y: scroll;
    width: 1070px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/peopleCenter/step/Home.vue